import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import {
  ServicePlanFieldError,
  ServicePlanStepComponent,
} from 'src/app/models/service-plan/service-plan-field-error'
import { ServicePlanStateService } from 'src/app/services/service-plan/service-plan-state.service'

// Step 5 — Child / family goals (story e8-4, GSP/First Service Plan only — Planned
// Transition skips this step entirely via the existing visibility rules, untouched by
// this story). A single optional free-text field: nothing to validate, matching
// NdisPlanStepComponent's/NdisClassificationStepComponent's own precedent
// (isLiveValid intentionally omitted, Continue is never blocked here).
@Component({
  selector: 'app-service-plan-family-goals-step',
  templateUrl: './family-goals-step.component.html',
  styleUrls: ['./family-goals-step.component.scss'],
  standalone: false,
})
export class FamilyGoalsStepComponent
  implements OnInit, OnDestroy, ServicePlanStepComponent
{
  form!: FormGroup<{
    familyGoals: FormControl<string | null>
  }>

  familyGoalsLabel = ''

  private subscription?: Subscription

  constructor(
    private state: ServicePlanStateService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.familyGoalsLabel = this.translate.instant(
      'SERVICE_PLAN.STEP.FAMILY_GOALS.FIELD_LABEL',
    )

    const payload = this.state.getPayload()
    this.form = new FormGroup({
      familyGoals: new FormControl<string | null>(payload.familyGoals),
    })

    this.subscription = this.form.valueChanges.subscribe((value) => {
      this.state.updatePayload({ familyGoals: value.familyGoals ?? null })
    })
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe()
  }

  // ServicePlanStepComponent contract — this step's only field is optional (AC5):
  // Continue is never blocked here, and isLiveValid is intentionally omitted (shell
  // default: not disabled).
  isValid(): boolean {
    return true
  }

  getValidationErrors(): ServicePlanFieldError[] {
    return []
  }
}
